import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function saveSubscribedUser(payload) {
  return { type: actionTypes.SAVE_SUBSCRIBED_USER, payload };
}
export function saveSubscribedUserSuccess(payload) {
  return { type: actionTypes.SAVE_SUBSCRIBED_USER_SUCCESS, payload };
}

export function updateSubscribedUser(payload) {
  return { type: actionTypes.UPDATE_SUBSCRIBED_USER, payload };
}
export function updateSubscribedUserSuccess(payload) {
  return { type: actionTypes.UPDATE_SUBSCRIBED_USER_SUCCESS, payload };
}

export function getSubscribedUser(payload) {
  return { type: actionTypes.GET_SUBSCRIBED_USER, payload };
}

export function getSubscribedUserSuccess(payload) {
  return { type: actionTypes.GET_SUBSCRIBED_USER_SUCCESS, payload };
}

export function getSubscribedUsers(payload) {
  return { type: actionTypes.GET_SUBSCRIBED_USERS, payload };
}

export function getSubscribedUsersSuccess(payload) {
  const byId = keyBy(payload, (user) => user.subscribedusersUid);
  return { type: actionTypes.GET_SUBSCRIBED_USERS_SUCCESS, payload: { byId } };
}

export function deleteSubscribedUser(payload) {
  return { type: actionTypes.DELETE_SUBSCRIBED_USER, payload };
}

export function deleteSubscribedUserSuccess(payload) {
  return { type: actionTypes.DELETE_SUBSCRIBED_USER_SUCCESS, payload };
}

export function generatePDF(payload) {
  return { type: actionTypes.GENERATE_PDF, payload };
}
export function generatePDFSuccess(payload) {
  return { type: actionTypes.GENERATE_PDF_SUCCESS, payload };
}

export function getPdfStatus(payload) {
  return { type: actionTypes.GET_PDF_STATUS, payload };
}

export function getPdfStatusSuccess(payload) {
  return { type: actionTypes.GET_PDF_STATUS_SUCCESS, payload };
}

export function getPdfs(payload) {
  return { type: actionTypes.GET_PDFS, payload };
}
export function getPdfsSuccess(payload) {
  const byId = keyBy(payload, (pdf) => pdf.connections_pdfUid);
  return { type: actionTypes.GET_PDFS_SUCCESS, payload: { byId } };
}

export function deletePdf(payload) {
  return { type: actionTypes.DELETE_PDF, payload };
}

export function deletePdfSuccess(payload) {
  return { type: actionTypes.DELETE_PDF_SUCCESS, payload };
}
